import React, { useState } from "react";
import { ButtonProps, CommandBarButton, depascalize } from "sprint-common-web";

import { isCloudAssetDeprecated, isInPreparation } from "../../../CloudAssetDetails";
import { CloudAssetStatus } from "../../../CloudAssetStatus";
import { useCloudAssetDetails } from "../../../common/hooks/useCloudAssetDetails";
import { DeprecateStatusDialog } from "./status-dialogs/DeprecateStatusDialog";

export type AssetStatusButtonProps = Pick<ButtonProps, "disabled">;

interface StatusButtonConfig {
    status: CloudAssetStatus;
    title: "Deprecate";
    icon: string;
}

export const CloudAssetStatusButton: React.FunctionComponent<AssetStatusButtonProps | undefined> = (
    props: AssetStatusButtonProps
) => {
    const { data: assetDetails } = useCloudAssetDetails();

    const [pickedStatus, setPickedStatus] = useState<CloudAssetStatus>();

    if (!assetDetails) {
        return null;
    }

    const statusButtons: StatusButtonConfig[] = [
        {
            status: CloudAssetStatus.Deprecated,
            title: "Deprecate",
            icon: "PageRemove"
        }
    ];

    const getStatusButtonDetails = (status?: CloudAssetStatus) => {
        return statusButtons.find((details: StatusButtonConfig) => details.status === status);
    };

    const getCurrentIcon = () => {
        return getStatusButtonDetails(assetDetails?.status)?.icon;
    };

    const pickStatusAndOpenConfirmDialog = (status: CloudAssetStatus) => {
        setPickedStatus(status);
    };

    const clearStatus = () => {
        setPickedStatus(undefined);
    };

    const isOpened = !!pickedStatus;

    const disabled = isCloudAssetDeprecated(assetDetails) || isInPreparation(assetDetails);

    return (
        <>
            <CommandBarButton
                text={`Status: ${depascalize(CloudAssetStatus[assetDetails.status]) || "..."}`}
                icon={getCurrentIcon()}
                testId="asset-status-dropdown"
                disabled={props?.disabled || (assetDetails && assetDetails.status === CloudAssetStatus.Deprecated)}
                menuItems={statusButtons.map((button: StatusButtonConfig) => ({
                    text: button.title,
                    icon: button.icon,
                    disabled,
                    onClick: () => pickStatusAndOpenConfirmDialog(button.status)
                }))}
            />
            <DeprecateStatusDialog isOpened={isOpened} onDismiss={clearStatus} />
        </>
    );
};
